var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2522_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.30005H14.6C15.2 8.30005 15.6 8.70005 15.6 9.30005V16.9001C15.6 17.5001 15.2 17.9001 14.6 17.9001H4C3.4 17.9001 3 17.5001 3 16.9001V9.30005C3 8.70005 3.5 8.30005 4 8.30005Z",
    fill: "#323232",
    stroke: "#323232",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.6V5.2C13.5 2.9 11.6 1 9.30005 1C7.00005 1 5.09998 2.9 5.09998 5.2V8.3",
    stroke: "#323232",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30005 13.1C9.79711 13.1 10.2 12.6971 10.2 12.2001C10.2 11.703 9.79711 11.3 9.30005 11.3C8.80299 11.3 8.40002 11.703 8.40002 12.2001C8.40002 12.6971 8.80299 13.1 9.30005 13.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30005 13.1001V14.8001",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2522_5589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwIcon);
export default __webpack_public_path__ + "static/media/pwIcon.9f6c34be2b926e4e2db93204b90e34be.svg";
export { ForwardRef as ReactComponent };